import React from 'react'
import { Box, CircularProgress, Link, List, ListItem, ListItemText, Typography } from '@material-ui/core'

const KitList = ({ items, title, loading, error }) => {
    return (
        <Box>
            <Typography component="h1" display="block" color="primary" variant="h1">
                {title}
            </Typography>

            {loading && <CircularProgress />}
            {error && <Typography color="error">שגיאה בטעינת הנתונים</Typography>}

            <List
                style={{
                    listStyleType: 'disc',
                    paddingInlineStart: '20px',
                }}>
                {(items || []).map((item, index) => (
                    <ListItem key={`item-${index}`} style={{ display: 'list-item' }}>
                        <ListItemText
                            primary={
                                <>
                                    {item.name}
                                    {item.linkUrl && (
                                        <>
                                            {' '}
                                            <Link href={item.linkUrl} underline="always" target="_blank">
                                                {item.linkText || item.linkUrl}
                                            </Link>
                                        </>
                                    )}
                                </>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}

export default KitList
